/**
 * Define storage types
 */
const storageType = {
    LANGUAGE: 'LANGUAGE',
    TRANSLATIONS: 'TRANSLATIONS',
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    AUTH_USER: 'AUTH_USER',
    USER_ROLE_ID: 'USER_ROLE_ID',
    ACTIVE_MENU_ID: 'ACTIVE_MENU_ID',
    CATEGORY_ID: 'CATEGORY_ID',
    CATEGORY_ARR: 'CATEGORY_ARR',
    CART_ITEMS: 'CART_ITEMS',
    ACTIVE_ORDER_NO: 'ACTIVE_ORDER_NO',
};
export default storageType;